import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import { api } from "../../environments/environment";
import {  Message } from "@stdoutsrl/design-kit";
import { LoaderService } from "../service/loader.service";
import { io, Socket } from 'socket.io-client';

@Component({
  selector: "app-moderation",
  templateUrl: "./moderation.component.html",
  styles: [],
  standalone: false,
})
export class ModerationComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private activatedRoute: ActivatedRoute,
  ) { }
  emojiList: string[] = ['🇮🇹', '😀', '😃', '😄', '😁', '😆', '🥹', '😅', '😂', '🤣', '🥲', '☺️', '😊', '😇', '🙂', '😉', '😌', '😍', '🥰', '😘', '😗', '😚', '😋', '😛', '😝', '😜', '😏', '🥳', '🤩', '🥸', '😎', '🧐', '🤨', '🤪']
  origin = ''
  idLive = ''
  animatedButton = ''
  currentStep = -2
  timerStart = 5
  qrCode = ''
  baseTimer = 10
  users: { nickname: string;kicked:boolean; points: number, profile_icon: string, color?: string, id: number,left_at?:any }[] = []
  presentationHasStarted = false
  private socket!: Socket;
  urlSocket: string = api.socketUrl;
  quiz: any = {}
  session: any = {}
  timerQuestion: any
  timerQuestionStartDate: any
  barTimeStopped = false
  remainingTimeTimer: number = -1
  showTimer = false
  endQuiz = false
  showRank = false
  endedTimeQuestion = false
  rankedUsers: any[] = []
  userToBan: any

  ngOnInit(): void {
    this.idLive = this.activatedRoute.snapshot.paramMap.get('id')!;
    this.origin = window.location.host
    this.qrCode = `${this.origin}/live/${this.idLive}`
    if (this.idLive) {
      this.getEventDetails()
    } else {
      this.message.showMessage('Insert live id', 'error')
    }
  }

  connectToSocket() {
    this.socket = io(this.urlSocket, {
      transports: ["websocket"],
      auth: {
        joinCode: this.idLive,
        token: (localStorage.getItem('token')),
        liveId: this.session.id
      }
    });
    this.socket.on("connected", (socket) => {

      this.users = socket.users.map((res: any) => {
        return JSON.parse(res)
      })
      console.log(this.users);

    });
    this.listToAllEvents()
  }

  listToAllEvents() {
    this.u1()
    this.u2()
    this.u3()
    this.u4()
    this.u5()
    this.error()
  }

  u1() {
    this.socket.on('u1', (event) => {
      let myUser =  this.users.find((user:any)=> user.id == event.id)
      if(myUser){
        this.users[this.users.findIndex((user:any)=> user.id == event.id)] = event
      }else{
        this.users.push(event)
      }
      
    });
  }

  u2() {
    this.socket.on('u2', (event) => {
      let myIndex = this.users.findIndex((user: any) => user.id == event.id)
      this.users[myIndex].color = event.value
      setTimeout(() => {
        myIndex = this.users.findIndex((user: any) => user.id == event.id)
        this.users[myIndex].color = 'rgba(255, 255, 255 ,0.25)'
      }, 1000);
    });
  }

  u3() {
    this.socket.on('u3', (event) => {
      console.log('Evento socket3:', event);
    });
  }

  u4() {
    this.socket.on('u4', (event: any) => {
      console.log('Evento socket4:', event);
      this.generateEmoji(event.value)
    });
  }

  u5() {
    this.socket.on('u5', (event) => {
      console.log('Evento socket5:', event);
    });
  }

  error() {
    this.socket.on('error', (error) => {
      console.error('Errore Socket.IO:', error);
    });
  }

  generateEmoji(emoji: string) {
    let id = Math.floor(Math.random() * 1000000);
    let myFountain = document.getElementById('fountain');
    if (myFountain) {
      let myNewEmoji = document.createElement('div');
      myNewEmoji.style.fontSize = '40px'
      myNewEmoji.innerHTML = emoji;
      myNewEmoji.id = id.toString();
      let myXPosition = Math.floor(Math.random() * (100 - -100 + 1)) - 100;

      const animationName = 'floatUp';
      const keyframes = `
@keyframes ${animationName + id} {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  10% {
    transform: translateY(-50px) translateX(${myXPosition * 0.1
        }px) rotate(50deg)
  };
  20% {
    transform: translateY(-50px) translateX(${myXPosition * 0.2
        }px) rotate(100deg)
  };
  30% {
    transform: translateY(-50px) translateX(${myXPosition * 0.3
        }px) rotate(150deg)
  };
  40% {
    transform: translateY(-50px) translateX(${myXPosition * 0.4
        }px) rotate(200deg)
  };
  50% {
    transform: translateY(-50px) translateX(${myXPosition * 0.5
        }px) rotate(250deg)
  };
  60% {
    transform: translateY(-50px) translateX(${myXPosition * 0.6
        }px) rotate(300deg)
  };
  70% {
    transform: translateY(-50px) translateX(${myXPosition * 0.7
        }px) rotate(350deg)
  };
  80% {
    transform: translateY(-50px) translateX(${myXPosition * 0.8
        }px) rotate(400deg);
        opacity: 1;
  }
  100% {
    transform: translateY(10px) translateX(${myXPosition}px) rotate(500deg);
        opacity: 0;
  }
}

.${animationName + id + 'class'}{
  animation: ${animationName + id} 2.5s ease;
  position:absolute
}
`;
      const styleSheet = document.createElement('style');
      styleSheet.innerHTML = keyframes;
      document.body.appendChild(styleSheet);
      myNewEmoji.className = animationName + id + 'class';
      myFountain.appendChild(myNewEmoji);
      setTimeout(() => {
        myNewEmoji.remove();
        styleSheet.remove();
      }, 2499);
    }
  }

  getEventDetails() {
    this.loader.on()
    this.rest.get(`/quiz-session/${this.idLive}`).subscribe({
      next: (value: any) => {
        this.quiz = value.quiz
        this.session = value
        this.loader.off(true)
        this.connectToSocket()
      },
      error: (value) => {
        this.loader.off(true)
      },
    })
  }

  activateAnimation(button: string) {
    this.animatedButton = button
    setTimeout(() => {
      this.animatedButton = ''
    }, 1000);
  }

  // timeStart() {
  //   if (this.timerStart > 0) {
  //     setTimeout(() => {
  //       this.timerStart = this.timerStart - 1
  //       this.timeStart()
  //     }, 999);
  //   } else {
  //     this.currentStep = this.session?.current_question?.order_index - 1
  //     this.showTimer = true
  //     setTimeout(() => {
  //       this.sendQuestion()
  //     }, 100);

  //   }
  // }

  // startQuiz() {
  //   this.loader.on()
  //   this.rest.patch(`/quiz-session/${this.session.id}/start`, {}).subscribe({
  //     next: (value) => {
  //       this.loader.off(true)
  //       this.currentStep = -1
  //       this.timeStart()
  //     },
  //     error: (value) => {
  //       this.loader.off(true)
  //     },
  //   })
  // }

  startBarTimer() {
    let bar = document.getElementById('timer-question')
    if (bar) {
      let totalTimerQuestion = (this.quiz.questions[this.currentStep].question_settings.duration_seconds ?? this.baseTimer) * 1000
      this.barTimeStopped = false
      this.timerQuestionStartDate = new Date().getTime()
      this.timerQuestion = setTimeout(() => {
        this.endQuestion()
      }, this.remainingTimeTimer == -1 ? totalTimerQuestion : this.remainingTimeTimer);
      if (this.remainingTimeTimer == -1) {
        bar.style.transitionDuration = `${(this.quiz.questions[this.currentStep].question_settings.duration_seconds ?? this.baseTimer) * 1000}ms`
      } else {
        bar.style.transitionDuration = `${this.remainingTimeTimer}ms`
      }
      bar.style.width = '0px'
      bar.style.transitionTimingFunction = 'linear'
    }
  }

  stopBarTimer() {
    let bar = document.getElementById('timer-question')
    if (bar) {
      this.barTimeStopped = true
      clearTimeout(this.timerQuestion)
      let passedTime = new Date().getTime() - this.timerQuestionStartDate
      let totalTimeQuestion = (this.quiz.questions[this.currentStep].question_settings.duration_seconds ?? this.baseTimer) * 1000
      if (this.remainingTimeTimer != -1) {
        totalTimeQuestion = this.remainingTimeTimer
      }
      let reverseTimer = 0
      if (this.remainingTimeTimer != -1) {
        reverseTimer = ((this.quiz.questions[this.currentStep].question_settings.duration_seconds ?? this.baseTimer) * 1000) - this.remainingTimeTimer
      }
      this.remainingTimeTimer = totalTimeQuestion - passedTime
      let percBar = 1 - ((passedTime + reverseTimer) / ((this.quiz.questions[this.currentStep].question_settings.duration_seconds ?? this.baseTimer) * 1000))
      bar.style.transitionDuration = `0ms`
      bar.style.width = (window.innerWidth * percBar) + 'px'
    }
  }

  endQuestion() {
    this.showTimer = false
    this.barTimeStopped = false
    setTimeout(() => {
      if (this.quiz.questions.length > (this.currentStep + 1)) {
        this.remainingTimeTimer = -1
        this.showTimer = true
        setTimeout(() => {

          this.rest.patch(`/quiz-session/${this.session.id}/stopTimeQuestion`, {}).subscribe({
            next: (value) => {
              this.endedTimeQuestion = true
            },
            error: (value) => {
            },
          })
        }, 100);
      } else {
        this.endQuiz = true
        this.getRankedUsers()
        this.currentStep = this.currentStep + 1
      }
    }, 0);
  }

  // nextQuestion() {
  //   this.rest.patch(`/quiz-session/${this.session.id}/next`, {}).subscribe({
  //     next: (value) => {
  //       this.endedTimeQuestion = false
  //       this.currentStep = this.currentStep + 1
  //       this.startBarTimer()
  //     },
  //     error: (value) => {
  //     },
  //   })
  // }

  // sendQuestion() {
  //   this.rest.post(`/quiz-session/${this.session.id}/sendQuestion`, {}).subscribe({
  //     next: (value) => {
  //       this.startBarTimer()
  //     },
  //     error: (value) => {
  //     },
  //   })
  // }

  getRankedUsers() {
    this.rankedUsers = this.users.sort((a, b) => b.points - a.points);
    this.showRank = true
  }

  banUser() {
  let deletedUser = JSON.parse(JSON.stringify(this.userToBan))
    this.loader.on()
    this.rest.patch(`/quiz-session/${this.session.id}/kick/${deletedUser.id}`,{}).subscribe({
            next: (value) => {
              this.loader.off(true)
              let indexDelete = this.users.findIndex((user:any)=> user.id == deletedUser.id)
              // this.users.splice(indexDelete,1)
              this.users[indexDelete].left_at = Date.now()
              this.users[indexDelete].kicked = true
              this.userToBan = null
            },
            error: (value) => {
               this.loader.off(true)
            },
          })
    // this.userToBan = null
    // let userToDisintegrate = document.getElementById(deletedUser.id)
    // let containerUser = document.getElementById('container-' + deletedUser.id)
    // // console.log(userToDisintegrate);
    // const canvas: any = document.getElementById('canvas');
    // if (canvas && userToDisintegrate && containerUser) {
    //   const ctx = canvas.getContext('2d');
    // }

  }

}
